import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { CbToggleModule } from '@chubb/ui-components';
import { CbButtonModule } from '@chubb/ui-components/cb-button';
import { CbModalModule } from '@chubb/ui-components/cb-modal';
import { BaseCoverageWidgetComponent } from '../../../shared/components/base-coverage.widget.component';

@Component({
  selector: 'app-underwriting-terms',
  imports: [FormsModule, CbToggleModule, CbModalModule, CbButtonModule],
  templateUrl: './underwriting-terms.component.html',
  styleUrl: './underwriting-terms.component.scss',
})
export class UnderwritingTermsComponent extends BaseCoverageWidgetComponent {
  open = false;

  handleModal() {
    this.open = !this.open;
  }

  percentile(val: string): number {
    return parseInt(val) / 100;
  }
}
